import React, { useEffect, useState, useRef } from "react";
import './DocRequestForm.scss'
import { getClientsByCases, RequestClientDistrictCourt, RequestClientHighCourt } from "../../services/api/AddDocApi";
import { getCourtTypeByCourtRef } from "../../services/api/MyClientsApi";
import { useParams } from "react-router-dom";
import { useToast } from "../../context/ToastContext";

export const DocRequestForm = ({ initialData, selectedCourtType, onSuccess, onCancel, isModal = false }) => {
  const { courtref } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showToast } = useToast();
  const modalRef = useRef(null);
  
  const clientSelectRef = useRef(null);
  const nameInputRef = useRef(null);
  const descriptionTextareaRef = useRef(null);
  const hasFocusedRef = useRef(false);
  const [clientsLoaded, setClientsLoaded] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    courtRef: courtref,
    description: "",
    clientId: "",
  });
  const [clients, setClients] = useState([]);

  // Add auto-focus effect
  useEffect(() => {
    // Prevent multiple focus attempts
    if (hasFocusedRef.current) return;

    // Wait for clients to be loaded before focusing
    if (!clientsLoaded) return;

    // Add a small delay to ensure DOM is ready
    const focusTimeout = setTimeout(() => {
      const clientSelect = clientSelectRef.current;
      if (clientSelect && !hasFocusedRef.current && clients.length > 0) {
        clientSelect.focus();
        hasFocusedRef.current = true;
      }
    }, 150);

    return () => clearTimeout(focusTimeout);
  }, [clientsLoaded, clients.length]);

  // Add Enter key submission functionality
  const handleFormKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      const target = e.target;
      const tagName = target.tagName.toLowerCase();
      const isSelect = tagName === 'select';
      const isTextarea = tagName === 'textarea';
      const isButton = tagName === 'button';
      
      // Allow Enter in textareas, selects, and buttons
      if (isTextarea || isSelect || isButton) {
        return;
      }
      
      // For input fields, provide tab-like navigation
      if (target === nameInputRef.current) {
        e.preventDefault();
        descriptionTextareaRef.current?.focus();
        return;
      }
      
      // For other inputs, submit if form is valid
      e.preventDefault();
      if (isFormValid() && !isSubmitting) {
        handleSubmit(e);
      }
    }
  };

  // Handle click outside modal to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isModal && modalRef.current && !modalRef.current.contains(event.target)) {
        onCancel();
      }
    };

    if (isModal) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModal, onCancel]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await getClientsByCases(courtref);
        const clientList = res?.data?.clients || [];
        console.log(clientList, "ppppppppppo");
        setClients(clientList);
        setClientsLoaded(true); 
      } catch (err) {
        console.error("Failed to fetch clients:", err);
        setClientsLoaded(true); 
      }
    };
    fetchClients();
  }, [courtref]);

  const isFormValid = () => {
    return formData.clientId && formData.name.trim() && formData.description.trim();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent multiple submissions

    setIsSubmitting(true);

    try {
      const courtTypeRes = await getCourtTypeByCourtRef(formData.courtRef);
      const courtSource = courtTypeRes?.data?.source;
      console.log(courtSource, "courtSource");

      let response;
      if (courtSource === "HighCourt") {
        console.log(formData, "highhhformmm");
        response = await RequestClientHighCourt(formData);
      } else if (courtSource === "DistrictCourt") {
        console.log(formData, "distriiiihformmm");
        response = await RequestClientDistrictCourt(formData);
      } else {
        throw new Error("Unknown court type received.");
      }

      console.log("Request Document Response:", response);
      showToast("Document request submitted successfully!", "success");
      onSuccess(formData.courtRef);
      // Note: Don't reset isSubmitting here as the modal/form will close

    } catch (err) {
      console.error("Failed to request doc:", err);
      showToast("Failed to request document.", "error");
      setIsSubmitting(false); // Reset on error
    }
  };

  return (
    <div className="add-doc-modal-main-container" ref={modalRef} onKeyDown={handleFormKeyDown}>
      <div className="add-doc-modal">
        <h3 className="add-doc-modal-form-title">Request For Document</h3>
        {isModal && (
          <button
            className="add-doc-modal-form-close-button"
            onClick={onCancel}
            aria-label="Close"
          >
            &times;
          </button>
        )}
      </div>
      
      <form onSubmit={handleSubmit} className="doc-form">
        <label>
          Select Client:
          <select
            ref={clientSelectRef}  // Add ref here
            name="clientId"
            value={formData.clientId}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Client --</option>
            {clients.map((client) => (
              <option key={client.clientId} value={client.clientId}>
                {client.name}
              </option>
            ))}
          </select>
        </label>

        <label>
          Name:
          <input 
            ref={nameInputRef}
            name="name" 
            value={formData.name} 
            onChange={handleChange} 
            placeholder="Enter document name"
            required 
          />
        </label>
        
        <label>
          Court Ref:
          <input name="courtRef" value={formData.courtRef} disabled />
        </label>
        
        <label>
          Description:
          <textarea 
            ref={descriptionTextareaRef}  // Add ref here
            name="description" 
            value={formData.description} 
            onChange={handleChange}
            placeholder="Enter document description"
            required 
          />
        </label>
        
        <div className="add-doc-form-actions">
          <button
            type="submit"
            disabled={!isFormValid() || isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
          <button type="button" onClick={onCancel}>Cancel</button>
        </div>
      </form>
    </div>
  );
};